module.exports = __webpack_public_path__ + "static/6-af0bb3dbcc6c3ef86a3d3802d85599c6.jpg";